import { mod, panic } from "@opendaw/lib-std";
import { UnionAdapterTypes } from "../UnionAdapterTypes";
export var RegionEditing;
(function (RegionEditing) {
    RegionEditing.cut = (region, cut, consolidate) => {
        if (region.position >= cut || cut >= region.complete) {
            return;
        }
        if (UnionAdapterTypes.isLoopableRegion(region)) {
            const { position, complete, loopOffset, loopDuration } = region;
            region.duration = cut - position;
            region.copyTo({
                position: cut,
                duration: complete - cut,
                loopOffset: mod(loopOffset + (cut - position), loopDuration),
                consolidate
            });
        }
        else {
            return panic("Not yet implemented");
        }
    };
    RegionEditing.clip = (region, begin, end) => {
        if (UnionAdapterTypes.isLoopableRegion(region)) {
            const { position, complete, loopOffset, loopDuration } = region;
            if (begin - position <= 0) {
                return panic(`first part duration will be zero or negative(${begin - position})`);
            }
            if (complete - end <= 0) {
                return panic(`second part duration will be zero or negative(${complete - end})`);
            }
            region.duration = begin - position;
            region.copyTo({
                position: end,
                duration: complete - end,
                loopOffset: mod(loopOffset + (end - position), loopDuration)
            });
        }
        else {
            return panic("Not yet implemented");
        }
    };
})(RegionEditing || (RegionEditing = {}));
